export default __webpack_public_path__ + "static/media/iconHomeBack.de737263.svg";